import React, { useEffect } from "react";
import { Offcanvas, Table } from "react-bootstrap";
import { MdRestore } from "react-icons/md";
import { NoDataFoundTable } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Pagination from "../../../Pagination";

const DeletedCustomEditCheckMeta = ({
  tableRef,
  onMouseDown,
  deletedCustomEditCheck,
  softDeleteRestoreStudyLevelCustomEditCheck,
  Show,
  Hide,
  Title,
  pageNumberDeleted,
  itemsPerPageDeleted,
  deletedCustomEditCheckCount,
  getDeletedStudyLevelCustomEditCheck,
  setPageNumberDeleted,
  setItemsPerPageDeleted,
}) => {
  const startIndex = (pageNumberDeleted - 1) * itemsPerPageDeleted;
  const totalPage = Math.ceil(
    deletedCustomEditCheckCount / itemsPerPageDeleted
  );
  useEffect(() => {
    getDeletedStudyLevelCustomEditCheck(pageNumberDeleted, itemsPerPageDeleted);
  }, [pageNumberDeleted, itemsPerPageDeleted]);
  return (
    <>
      <Offcanvas
        show={Show}
        onHide={Hide}
        style={{ width: 575 }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {deletedCustomEditCheck?.length === 0 ? (
            <div className=" hstack justify-content-center h-100">
              <NoDataFoundTable MSG={"Custom edit check not deleted yet."} />
            </div>
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Type</th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>Label</th>
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>Category</th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 5)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Restore
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {deletedCustomEditCheck?.map((check, index) => (
                    <tr key={index} title="View Details">
                      <td className="text-center">{index + 1 + startIndex}.</td>
                      <td>
                        {check?.type === "byEvent" ? "By Event" : "Global"}
                      </td>
                      <td>{check?.label}</td>
                      <td>
                        {check?.category === "query"
                          ? "Auto Query"
                          : check?.category === "includeExclude"
                          ? "Inclusion/Exclusion"
                          : "Notification"}
                      </td>
                      <td className="text-center" title="Restore">
                        <MdRestore
                          style={{ fontSize: 16 }}
                          onClick={(e) =>
                            softDeleteRestoreStudyLevelCustomEditCheck(
                              check?._id,
                              "restore"
                            )
                          }
                          className="text-success CP"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumberDeleted}
                  itemsPerPage={itemsPerPageDeleted}
                  totalItems={deletedCustomEditCheckCount}
                  setPageNumber={setPageNumberDeleted}
                  setItemsPerPage={setItemsPerPageDeleted}
                />
              </div>
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default DeletedCustomEditCheckMeta;
